import gql from "graphql-tag";

export const QUERY = gql`
	query getRateCard(
		$userId: String!,
		$platform: Platform!,
		$productType: ProductType!,
		$productSubtype: ProductSubType!,
	) {
			user(id: $userId) {
				id
				rateCard(
					platform: $platform
					productType: $productType
					productSubtype: $productSubtype
				) {
					rateCardName
					productPriceInfoList {
						countryCode
						subPeriodType
						formattedInitialUnitPrice
						formattedInitialSubtotalPrice
						formattedInitialSubtotalPriceBase
						productType
						initialTaxes {
							taxType
							billingTaxRatesUSId
							billingStateCode
							billingCountryCode
							amount
							formattedAmount
						}
						initialCurrency
						subPeriod
						productSubType
						productId
						formattedInitialPrice
						tokensCount
					}
					paymentOptions
					discountId
				}
			storedPaymentMethods {
				payPalEmailAddress
				holderName
				cardLastFour
				isValid
				expDate
				tokenId
				paymentProcessor
			}
			paymentStateAbbreviation
		}
	}
`;

export const PAYPAL_URL_QUERY = gql`
	query getPayPalURL(
		$userId: String!,
		$platform: Platform!,
		$productId: String!,
		$returnURL: String!,
		$cancelURL: String!,
	) {
		user(id: $userId) {
			id
			payPalURL(
				platform: $platform
				productId: $productId
				returnURL: $returnURL
				cancelURL: $cancelURL
			)
		}
	}
`;

export const CREDIT_CARD_PURCHASE_MUTATION = gql`
	mutation purchaseWithCreditCard($input: BillingPurchaseWithCreditCardInput) {
		purchaseWithCreditCard(input: $input) {
			success
			message
		}
	}
`;

export const PAYPAL_PURCHASE_MUTATION = gql`
	mutation purchaseWithPayPal($input: BillingPurchaseWithPayPalInput) {
		purchaseWithPayPal(input: $input) {
			success
			message
		}
	}
`;



// WEBPACK FOOTER //
// ./src/apps/payment/containers/AndroidPayment/queries.js